export type RouteErrorPresentation =
    | { kind: "not-found"; title: string; description: string }
    | { kind: "expired"; title: string; description: string }
    | { kind: "generic"; title: string; description: string };

export function getRouteErrorPresentation(
    message: string,
): RouteErrorPresentation {
    if (message === "Application form not found.") {
        return {
            kind: "not-found",
            title: "This application isn't here",
            description:
                "The application link may be incorrect, or the form may have been removed.",
        };
    }

    if (
        message === "This application link has expired." ||
        message === "This application form is not available."
    ) {
        return {
            kind: "expired",
            title:
                message === "This application link has expired."
                    ? "This application link has expired"
                    : "This application isn't available",
            description:
                "Ask the provider for a new link, or return to Wags to keep looking.",
        };
    }

    return {
        kind: "generic",
        title: "This page didn't load",
        description: "Try loading the page again.",
    };
}
